import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { SupplierMapping, Unit } from '@synergy/models';

import {
    CLEAR_SUPPLIER_UNIT_MAPPINGS,
    RECEIVE_SUPPLIER_UNIT_MAPPING,
    RECEIVE_SUPPLIER_UNIT_MAPPINGS,
} from './supplier-unit-mapping-actions';

export interface SupplierUnitMappingReducerState {
    supplierMappings: PaginatedResponse<SupplierMapping<Unit>>;
}

const initialUnitsReducerState: SupplierUnitMappingReducerState = {
    supplierMappings: { items: [], limit: 10, page: 0, total: 0 },
};

export const supplierUnitMappingReducer = (
    state: SupplierUnitMappingReducerState = initialUnitsReducerState,
    action: AnyAction
): SupplierUnitMappingReducerState => {
    const { type, ...rest } = action;

    switch (type) {
        case RECEIVE_SUPPLIER_UNIT_MAPPING: {
            const items = [...state.supplierMappings.items];
            const index = items.findIndex(mapping => mapping.id === rest['supplierMapping'].id);
            if (index >= 0) {
                items[index] = rest['supplierMapping'];
            }

            return {
                ...state,
                supplierMappings: { ...state.supplierMappings, items },
            };
        }

        case RECEIVE_SUPPLIER_UNIT_MAPPINGS: {
            return {
                ...state,
                supplierMappings: rest['supplierMappings'],
            };
        }

        case CLEAR_SUPPLIER_UNIT_MAPPINGS: {
            return {
                ...state,
                supplierMappings: { ...state.supplierMappings, items: [] },
            };
        }

        default: {
            return state;
        }
    }
};
